module.exports = __webpack_public_path__ + "static/img/blog_new_1.aeaba67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_new_1.png
// module id = OaOS
// module chunks = 8